"use strict";
// Copyright (c) 2021 by Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerEventType = void 0;
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
var ContainerEventType;
(function (ContainerEventType) {
    ContainerEventType["AddModule"] = "addModule";
    ContainerEventType["EditContainer"] = "editContainer";
    ContainerEventType["RemoveContainer"] = "removeContainer";
})(ContainerEventType = exports.ContainerEventType || (exports.ContainerEventType = {}));
//# sourceMappingURL=Container.contracts.js.map